import React, { Component } from 'react'
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import cintillo from "../../assets/img/cintillo_membrete.jpg";
import { OPCIONES } from './Styles/StylesAsistencia';

class AsistenciaEstudiantes extends Component {
    state = {  }

    estudiantes = () => {
        const styles = StyleSheet.create(OPCIONES[0]);
        let { estudiantes } = this.props;

        let apellidos = (ape1, ape2) => {
            let apellido2 = ape2;
            if (ape2 === null) apellido2 = "";
            return `${ape1} ${apellido2}`
        }

        let nombres = (nom1, nom2) => {
            let nombre2 = nom2;
            if (nom2 === null) nombre2 = "";
            return `${nom1} ${nombre2}`
        }

        let num = 1
        let numero = () => { return num ++; }

        return (
            estudiantes.map(option => (
                <View style={[styles.row, {height: 20, marginLeft: 35}]} key={option.id_estudiante}>
                    <Text style={[styles.col2, {padding: 5, marginTop: -1}]}>{numero()}</Text>
                    <Text style={[styles.col13, {padding: 5, marginTop: -1}]}>{apellidos(option.apellido_1, option.apellido_2)}</Text>
                    <Text style={[styles.col13, {padding: 5, marginTop: -1}]}>{nombres(option.nombre_1, option.nombre_2)}</Text>
                    <Text style={[styles.col14, {padding: 5, marginTop: -1}]}>{`${option.nacionalidad} ${option.ci}`}</Text>
                    <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                    <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                    <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                    <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                    <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                    <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                </View>
            ))
        )
    }

    render() {
        let { seccion, autoridades } = this.props;
        const styles = StyleSheet.create(OPCIONES[0]);

        let semestre = (sem) => {
            let semestres = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"]

            return semestres[sem - 1]
        }

        return (
            <PDFViewer style={styles.section}>
                <Document title="Listados de Asistencia">
                    <Page size="A4" orientation="landscape" style={styles.body}>
                        <View style={styles.row}>
                            <Image
                                style={[styles.colContent40, styles.logo]}
                                src={cintillo}
                            />
                            <View style={[styles.row, {height: 20}]}>
                                <Text style={[styles.col1, styles.background, {padding: 5, marginTop: -1}]}>UNIDAD CURRICULAR</Text>
                                <Text style={[styles.col2, styles.background, {padding: 5, marginTop: -1}]}>SECC</Text>
                                <Text style={[styles.col3, styles.background, {padding: 5, marginTop: -1}]}>HORAS SEMANALES</Text>
                                <Text style={[styles.col4, styles.background, {padding: 5, marginTop: -1}]}>CARRERA</Text>
                                <Text style={[styles.col5, styles.background, {padding: 5, marginTop: -1}]}>LAPSO</Text>
                                <Text style={[styles.col2, styles.background, {padding: 5, marginTop: -1}]}>SEM.</Text>
                                <Text style={[styles.col6, styles.background, {padding: 5, marginTop: -1}]}>FECHA CONSIGNACION</Text>
                            </View>
                        </View>
                        <View style={[styles.row, {height: 40, marginLeft: 325, marginTop:-23}]}>
                            <Text style={[styles.col1, styles.materia]}>{seccion.materia}</Text>
                            <Text style={[styles.col2, styles.materia]}>{seccion.seccioName}</Text>
                            <Text style={[styles.col3]}></Text>
                            <Text style={[styles.col4, styles.materia]}>{seccion.carrera}</Text>
                            <Text style={[styles.col5]}></Text>
                            <Text style={[styles.col2, styles.materia]}>{semestre(seccion.semestreNum)}</Text>
                            <Text style={[styles.col6]}></Text>
                        </View>
                        <View style={[styles.row, {height: 20, marginTop: 3}]}>
                            <Text style={[styles.col7, {padding: 5, marginTop: -1}]}>REGISTRO DE ASISTENCIA MENSUAL</Text>
                            <Text style={[styles.col8, styles.background, {padding: 5, marginTop: -1}]}>FECHAS</Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1}]}></Text>
                        </View>
                        <View style={[styles.row, {height: 20}]}>
                            <Text style={[styles.col11, styles.background, {padding: 5, marginTop: -1}]}>ACTIVIDADES</Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1, height: 41}]}></Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1, height: 41}]}></Text>
                            <Text style={[styles.col9, {padding: 5, marginTop: -1, height: 41}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1, height: 41}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1, height: 41}]}></Text>
                            <Text style={[styles.col10, {padding: 5, marginTop: -1, height: 41}]}></Text>
                        </View>
                        <View style={[styles.row, {height: 20}]}>
                            <Text style={[styles.col12, styles.background, {padding: 5, marginTop: -1}]}>ESTUDIANTES</Text>
                        </View>
                        <View style={[styles.row, {height: 20, marginLeft: 35}]}>
                            <Text style={[styles.col2, {padding: 5, marginTop: -1}]}>N°</Text>
                            <Text style={[styles.col13, {padding: 5, marginTop: -1}]}>APELLIDOS</Text>
                            <Text style={[styles.col13, {padding: 5, marginTop: -1}]}>NOMBRES</Text>
                            <Text style={[styles.col14, {padding: 5, marginTop: -1}]}>CEDULA</Text>
                            <Text style={[styles.col15, styles.background, {padding: 5, marginTop: -1}]}>FIRMAS</Text>
                        </View>
                        
                        {this.estudiantes()}
                        
                        <View style={[styles.row, {height: 20, marginLeft: 34, marginTop: 3}]}>
                            <Text style={[styles.col16, styles.background, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col19, styles.background, {padding: 5, marginTop: -1}]}>APELLIDOS Y NOMBRES</Text>
                            <Text style={[styles.col20, styles.background, {padding: 5, marginTop: -1}]}>CEDULA</Text>
                            <Text style={[styles.col20, styles.background, {padding: 5, marginTop: -1}]}>FIRMA</Text>
                            <Text style={[styles.col21, styles.background, {padding: 5, marginTop: -1}]}>OBSERVACIONES</Text>
                        </View>
                        <View style={[styles.row, {height: 20, marginLeft: 34}]}>
                            <Text style={[styles.col17, styles.background, {padding: 5, marginTop: -1}]}>DOCENTE</Text>
                            <Text style={[styles.col19, {padding: 5, marginTop: -1}]}>{seccion.prof}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}>{seccion.ciProf}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col21, {padding: 5, marginTop: -1}]}></Text>
                        </View>
                        <View style={[styles.row, {height: 20, marginLeft: 34}]}>
                            <Text style={[styles.col17, styles.background, {padding: 5, marginTop: -1}]}>COORDINACIÓN</Text>
                            <Text style={[styles.col19, {padding: 5, marginTop: -1}]}>{autoridades.coordinador}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}>{autoridades.cordCi}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col21, {padding: 5, marginTop: -1}]}></Text>
                        </View>
                        <View style={[styles.row, {height: 20, marginLeft: 34}]}>
                            <Text style={[styles.col18, styles.background, {padding: 5, marginTop: -1}]}>CONTROL DE ESTUDIOS</Text>
                            <Text style={[styles.col19, {padding: 5, marginTop: -1}]}>{autoridades.ctrlName}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}>{autoridades.ctrlCi}</Text>
                            <Text style={[styles.col20, {padding: 5, marginTop: -1}]}></Text>
                            <Text style={[styles.col21, {padding: 5, marginTop: -1}]}></Text>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default AsistenciaEstudiantes;


// WEBPACK FOOTER //
// ./src/components/Reportes/AsistenciaEstudiantes.jsx